import { get } from "lodash";

export default {
  namespaced: true,
  state:      {
    isAnimationInProgress:  false,
    showVideoPanel:         false,
    pageAnimation:          false,
    pageAnimationIndex:     0,
    isNewPageAdded:         false,
    sliderScroller:         0,
    isTrimmingEnable:       false,
    isTrimmedVideoPlaying:  false,
    displayAnimationPanel:  false,
    isVideoMoodOn:          false,
    isVideoEditor:          false,
    videoConfirmationModel: false,
    isDownloadInprogress:   false,
    isAudioTrimOn:          false,
    envelope:               null,
    videoModeDisableErr:    false,
    totalUploadFiles:       0,
    currentUploadFile:      0,
    showTextAiGenModal:     false,
    showTextAiRewriteModal: false,
    currentObjectText:      '',
  },
  getters: {
    getEnvelope(state) {
      return state.envelope;
    },
    getIsAudioTrimOn(state) {
      return state.isAudioTrimOn;
    },
    getVideoConfirmationModel(state) {
      return state.videoConfirmationModel;
    },
    getVideoModeDisableErrorModal(state) {
      return state.videoModeDisableErr;
    },
    getIsVideoMoodOn(state) {
      return state.isVideoMoodOn;
    },
    getIsVideoEditor(state) {
      return state.isVideoEditor;
    },
    getDisplayAnimationPanel(state) {
      return state.displayAnimationPanel;
    },
    getIsTrimmedVideoPlaying(state) {
      return state.isTrimmedVideoPlaying;
    },
    getIsTrimmingEnable(state) {
      return state.isTrimmingEnable;
    },
    getSliderScroller(state) {
      return state.sliderScroller;
    },
    getIsNewPageAdded(state) {
      return state.isNewPageAdded;
    },
    getPageAnimationIndex(state) {
      return state.pageAnimationIndex;
    },
    getPageAnimationPanel(state) {
      return state.pageAnimation;
    },
    getIsAnimationInProgress: state => state.isAnimationInProgress,
    getShowVideoPanel:        state => state.showVideoPanel,
    getIsDownloadInprogress:  state => state.isDownloadInprogress,
    getTotalUploadFiles:      state => state.totalUploadFiles,
    getCurrentUploadFile:     state => state.currentUploadFile,
    getShowTextAiGenModal:    state => state.showTextAiGenModal,

    getShowTextAiRewriteModal: state => state.showTextAiRewriteModal,
    getCurrentObjectText:      state => state.currentObjectText,
  },
  mutations: {
    updateEnvelope(state, payload) {
      state.envelope = payload;
    },
    UpdateIsAudioTrimOn(state, payload) {
      state.isAudioTrimOn = payload;
    },
    updateVideoConfirmationModel(state, payload) {
      state.videoConfirmationModel = payload;
    },
    updateVideoModeDisableError(state, payload) {
      state.videoModeDisableErr = payload;
    },
    updateIsVideoMoodOn(state, payload) {
      if (payload && !state.isVideoMoodOn) {
        try {
          /* this._vm.$gtag.event('VideoModeToggle', {
            event_category: 'Click',
            event_label:    'Video Mode Enabled',
            value:          { bank: this._vm.getBankId, user: this._vm.getUserId, productId: this._vm.getSelectedProduct.Id },
          }); */
          this._vm.$gtag.event('VideoModeEnabled', {
            event_bank:    this._vm.getBankId,
            event_user:    this._vm.getUserId,
            event_product: this._vm.getSelectedProduct.Id,
            event_label:   'Video Mode Enabled',
            value:         true,
          });
        } catch (ex) {
          console.log('Error sending analytics', ex.message);
        }
      }
      state.isVideoMoodOn = payload;
    },
    updateIsVideoEditor(state, payload) {
      state.isVideoEditor = payload
    },
    updateDisplayAnimationPanel(state, payload) {
      state.displayAnimationPanel = payload;
    },
    updateIsTrimmedVideoPlaying(state, payload) {
      state.isTrimmedVideoPlaying = payload;
    },
    updateISTrimmingEnable(state, payload) {
      state.isTrimmingEnable = payload;
    },
    updateSliderScroller(state, payload) {
      state.sliderScroller = payload;
    },
    updateIsNewPageAdded(state, payload) {
      state.isNewPageAdded = payload;
    },
    updatePageAnimationIndex(state, payload) {
      state.pageAnimationIndex = payload;
    },
    updatePageAnimationPanel(state, payload) {
      state.pageAnimation = payload;
    },
    setIsAnimationInProgress: (state, payload) => {
      state.isAnimationInProgress = payload;
    },
    updateShowVideoPanel: (state, payload) => {
      state.showVideoPanel = payload;
    },
    updateTotalUploadFiles: (state, payload) => {
      state.totalUploadFiles = payload;
    },
    updateCurrentUploadFile: (state, payload) => {
      state.currentUploadFile = payload;
    },
    updateShowTextAiGenModal: (state, payload) => {
      state.showTextAiGenModal = payload;
    },
    updateShowTextAiRewriteModal: (state, payload) => {
      state.showTextAiRewriteModal = payload;
    },
    updateCurrentObjectText: (state, payload) => {
      state.currentObjectText = payload;
    },
  },
};
